<template>
    <div class="clipbord-ctn">
      <div class="link-wrap" v-if="showCopyButton"><van-button size="small" :type="type || 'primary'" @click="doCopy(copyText)">{{btnText||"点击复制"}}</van-button></div>
      <div :class="`${!showContent ? 'zero-ctn':''}`"><textarea readonly @click="doCopy(this)" rows="1" class="link-text" ref="textArea" v-model="copyText"></textarea></div>
    </div>
</template>
<style lang="less">
.clipbord-ctn{
    display: inline-flex;
    align-items: center;
    align-content: center;
    flex-direction: row;
    flex-wrap: wrap;
  .link-wrap{
      display: flex;
      align-items: center;
      align-content: center;
      flex-direction: row;
      flex-wrap: wrap;
  }
  .link-text{
      display: block;
      background: #eee;
      border: #eee;
      border-radius: 0 0.4rem 0.4rem 0;
      white-space: nowrap;
      line-height: var(--van-button-small-height);
      height: var(--van-button-small-height);
      color: #000;
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      overflow: hidden;
      text-indent: 0.2rem;
  }
    .zero-ctn{
        overflow: hidden;
        width: 1px;
        height: 1px;
        position:absolute;
        opacity: 0;
    }
}

</style>
<script>
import {showNotify} from "vant";
import {ref, watch} from "vue";

export default{
    name: "ClipbordComponent",
    props: ['text', 'showCopyButton', 'showContent','btnText', "notifyText", "type"],
    setup(props){
        console.log(props)

        const textArea = ref(null);
        const copyText = ref(props.text);
        watch(props,(props)=>{
            copyText.value = props.text;
        });

        return {textArea,copyText}
    },
    methods:{
        doCopy(){
            this.textArea.value = this.copyText;
            this.textArea.select();
            document.execCommand('copy');
            showNotify({message: this.notifyText || "复制成功", type:"success"});
        }
    }
}
</script>
